import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { RouterPathService } from "../../../../core/common/variables/router-path.service";
import { TranslateService } from "../../../common/variables/translate-service";
import { ConfirmationBoxComponent } from "../confirmation-box/confirmation-box.component";
import { GlobalVariableService } from "../../../common/variables/global-variable";
import { GlobalService } from '../../services/global.service';
import { GlobalFunctionService } from '../../services/global-function.service';

@Component({
  selector: 'sen-app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {
  loginPath: string;
  settingPath: string;

  @ViewChild('userInfoBox', { read: ElementRef, static: true }) userInfo: ElementRef;

  constructor(private router: Router,
    public dialog: MatDialog,
    public globalService: GlobalService,
    public globalF: GlobalFunctionService,
    private routerPath: RouterPathService,
    public global: GlobalVariableService,
    public translate: TranslateService) {
    this.loginPath = `${this.routerPath.pathSeperator}${this.routerPath.loginString}`;
    this.settingPath = `${this.routerPath.pathSeperator}${this.routerPath.settingsPath}`;
  }

  ngOnInit(): void {
  }

  logoutUser() {
    let dialogRef = this.globalF.openConfirmationBox('LOG_OUT_QUE');
    dialogRef.afterClosed().subscribe((result: boolean) => {
      dialogRef.close();
      if (result) {
        if (window.location.origin.includes("localhost"))
         {
           this.router.navigate([this.loginPath]);
         } else {
           window.location.href = this.global.loginSol50Url;
         }
      }
    });
  }

  goToSettingPath() {
    this.router.navigate([this.settingPath]);
  }

  switchLng(slng: string) {
    localStorage.setItem('lng', slng);
    location.reload();
    // const qParam = {
    //   cmd: this.global.switchLng,
    //   lng: slng
    // }
    // this.globalService.getData(qParam).subscribe((data: any) => {
    //   try {
    //     if (data.ok.data) {
    //       location.reload();
    //     }
    //   } catch { }
    // });
  }

  getUserInfoWidth() {
    return `${this.userInfo.nativeElement.offsetWidth}px`;
  }
}
